<template>
  <section>
    <template v-if="value && !loading">
      <template v-if="value.repertoire.length">
        <ul class="grid grid-cols-1 gap-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 md:gap-y-6">
          <li
            v-for="(item, index) in value.repertoire"
            :key="item.object.id"
            :class="
              index > 0 && !((index + 1) % 7)
                ? 'lg:col-span-1 col-span-1 md:col-span-3 sm:col-span-2'
                : 'col-span-1'
            "
          >
            <AppRouterLink :to="{ name: 'EventView', params: { id: item.object.id } }">
              <EventCard :value="item.object" size="big" />
            </AppRouterLink>
          </li>
        </ul>
      </template>
      <p v-else class="text-center text-sm text-text-main">
        Подходящих событий не найдено. Попробуйте сбросить фильтр<br />или выбрать другие параметры
        поиска
      </p>
    </template>
    <template v-else>
      <CategoryResultsTilesSkeleton class="!px-0" />
    </template>
  </section>
</template>

<script setup lang="ts">
import type { Category } from '@/5_entities/Category'
import { EventCard } from '@/5_entities/Event'
import { AppRouterLink } from '@/6_shared/ui'
import CategoryResultsTilesSkeleton from './CategoryResultsTilesSkeleton.vue'

type PropType = {
  value?: Category
  loading?: boolean
}

withDefaults(defineProps<PropType>(), {
  value: undefined,
  loading: false
})
</script>
